export const CURSOR_OVERLAY_CONTAINER_ID = 'cursor-overlay-container';
